// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cE3W","colMin":"styles_colMin__1Vddk"};